import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Language/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	cultureCode: string;
	sortOrder: number;
	isoCode6391: string;
	isoCode6393: string;
	hasArticleBeforeIngredientName: boolean;
	translationCode: string | null;
	nameTranslations: {
		[key: string]: string;
	};
}
